import { panelCan, mainAppBadgeLabel } from "@/config/panels";

// Globalny mixin (rejestrowany w main.js przez Vue.mixin) - udostepnia w KAZDYM komponencie:
//  - this.panelCan('showBills')  -> czy element ma byc widoczny w aktywnym panelu (do v-if)
//  - this.$activePanel           -> aktualny panel (MAIN_APP|DOD|POD), np. do warunkow nie-boolowskich
//  - this.$mainAppBadge          -> etykieta opiekuna polaczonego z aplikacja ("(SeniorApp)" / "DNR")
// Reaktywne przez Vuex (zmiana panelu od razu przelicza widocznosc).
export default {
  computed: {
    $activePanel() {
      return this.$store.getters.getActivePanel;
    },
    $mainAppBadge() {
      return mainAppBadgeLabel(this.$store.getters.getActivePanel);
    },
  },
  methods: {
    panelCan(capability) {
      return panelCan(this.$store.getters.getActivePanel, capability);
    },
  },
};
